import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  concat,
  concatMap,
  map,
  take,
  tap,
} from 'rxjs';
import { environment } from '../../environments/environment';
import { Token } from '../models';
import { LogSource, LogType } from '../models/common';
import * as uuid from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  private logEnabled: boolean = false;
  private acceptedLevels: string[] = [];
  private acceptedSources: string[] = [];
  private logsToRun: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  private logsQueue: any = [];
  private startLog: any;

  constructor(private readonly http: HttpClient) {
    this.logsToRun
      .pipe(
        tap(() => {
          if (this.logsToRun.getValue().length > 0) {
            concat(this.logsToRun.getValue())
              .pipe(
                concatMap((data: any) =>
                  data.observable.pipe(map((data) => data))
                )
              )
              .subscribe({
                next: () => {},
                error: (err: any) => console.error('Error:', err),
                complete: () => {
                  this.logsQueue = [];
                },
              });
          }
        })
      )
      .subscribe();
  }

  public setLevels(levels: string[]) {
    this.acceptedLevels = levels;
  }

  public setSources(sources: string[]) {
    this.acceptedSources = sources;
  }

  public writeLog(
    message: string,
    type = LogType.TRACE,
    logSource = LogSource.SYSTEM,
  ): void {
    if (!this.kioskData?.access_token || !this.logEnabled) return;

    const url = `${environment.apiUrl}/api/KioskLog`;
    const hasLevel = (this.acceptedLevels ?? []).find(
      (l: string) =>
        l.toLowerCase() === type.replace('[', '').replace(']', '').toLowerCase()
    );
    const hasSource = (this.acceptedSources ?? []).find((s: string) => logSource === s);
    const messageToSend = `${new Date().toLocaleString('en-US', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      fractionalSecondDigits: 3,
    })} - ${message}`;
    console.log(messageToSend);

    if (
      (type === LogType.ERROR ||
      (this.logEnabled && !!hasLevel && !!hasSource))
    ) {
      this.logsQueue.push({
        id: uuid.v4(),
        observable: this.http
          .post<null>(url, {
            message: messageToSend,
          })
          .pipe(take(1)),
      });
    }

    if (this.startLog) {
      clearTimeout(this.startLog);
    }

    this.startLog = setTimeout(() => {
      this.logsToRun.next(this.logsQueue);
    }, 2000);
  }

  public setLogEnabled(enabled: boolean) {
    this.logEnabled = enabled;
  }

  private get kioskData(): Token | null {
    const kioskData = localStorage.getItem('kioskData');

    if (kioskData) {
      return JSON.parse(kioskData);
    }

    return null;
  }
}
